import React from 'react';

import Button from '@/shared/components/button/Button';

interface BackButtonProps {
	onClick: () => void;
	small?: boolean;
}

const BackButton = ({ onClick, small }: BackButtonProps) => (
	<Button
		iconName="icon-arrow-left"
		color="white"
		type="secondary"
		rounded
		onClick={onClick}
		className="back-button"
		small={small}
	/>
);

export default BackButton;
